export default __webpack_public_path__ + "static/media/dashboard_1.f6e1237e.png";